/**
 *@returns {void}
 */
export function PdfiumRunner() {
    const moduleString = 'Module';
    let pageLoaded = false;
    let moduleLoaded = false;
    const FPDF = {};
    let readBlockPtr;
    // eslint-disable-next-line
    var pdfiumWindow = pdfiumWindow ? pdfiumWindow : {};
    let documentDetails;
    const PDFiumModule = typeof (pdfiumWindow[`${moduleString}`]) !== 'undefined' ? (pdfiumWindow[`${moduleString}`]) : {};
    const F64 = Float64Array;
    const H = (t, s, d) => (f) => {
        const [m, ...a] = pdfiumWindow.heap(t, s);
        const v = f(...a.map((x) => x.p));
        if (!v) {
            m.free();
            return d;
        }
        const r = a.map((x) => x.v);
        m.free();
        return r;
    };
    Object.assign(FPDF, {
        LCD_TEXT: 0x02,
        NO_NATIVETEXT: 0x04,
        GRAYSCALE: 0x08,
        DEBUG_INFO: 0x80,
        NO_CATCH: 0x100,
        RENDER_LIMITEDIMAGECACHE: 0x200,
        RENDER_FORCEHALFTONE: 0x400,
        PRINTING: 0x800,
        REVERSE_BYTE_ORDER: 0x10,
        // eslint-disable-next-line
        Bitmap_Gray: 1,
        // eslint-disable-next-line
        Bitmap_BGR: 2,
        // eslint-disable-next-line
        Bitmap_BGRx: 3,
        // eslint-disable-next-line
        Bitmap_BGRA: 4,
        LAST_ERROR: {
            SUCCESS: 0,
            UNKNOWN: 1,
            FILE: 2,
            FORMAT: 3,
            PASSWORD: 4,
            SECURITY: 5,
            PAGE: 6
        }
    });
    /**
     *@returns {void}
     */
    function initializeFPDF() {
        FPDF.Init = PDFiumModule.cwrap('FPDF_InitLibrary');
        FPDF.RenderPageBitmap = PDFiumModule.cwrap('FPDF_RenderPageBitmap', '', ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number']);
        // eslint-disable-next-line
        FPDF.Bitmap_FillRect = PDFiumModule.cwrap('FPDFBitmap_FillRect', '', ['number', 'number', 'number', 'number', 'number', 'number']);
        // eslint-disable-next-line
        FPDF.Bitmap_CreateEx = PDFiumModule.cwrap('FPDFBitmap_CreateEx', 'number', ['number', 'number', 'number', 'number', 'number']);
        // eslint-disable-next-line
        FPDF.Bitmap_Destroy = PDFiumModule.cwrap('FPDFBitmap_Destroy', '', ['number']);
        FPDF.LoadPage = PDFiumModule.cwrap('FPDF_LoadPage', 'number', ['number', 'number']);
        FPDF.ClosePage = PDFiumModule.cwrap('FPDF_ClosePage', '', ['number']);
        FPDF.LoadCustomDocument = PDFiumModule.cwrap('FPDF_LoadCustomDocument', 'number', ['number', 'string']);
        FPDF.LoadMemDocument = PDFiumModule.cwrap('FPDF_LoadMemDocument', 'number', ['number', 'number', 'string']);
        FPDF.GetPageSizeByIndex = PDFiumModule.cwrap('FPDF_GetPageSizeByIndex', 'number', ['number', 'number', 'number', 'number']);
        FPDF.GetLastError = PDFiumModule.cwrap('FPDF_GetLastError', 'number');
        FPDF.GetPageCount = PDFiumModule.cwrap('FPDF_GetPageCount', 'number', ['number']);
        FPDF.CloseDocument = PDFiumModule.cwrap('FPDF_CloseDocument', '', ['number']);
        FPDF.DestroyLibrary = PDFiumModule.cwrap('FPDF_DestroyLibrary');
        FPDF.LoadTextPage = PDFiumModule.cwrap('FPDFText_LoadPage', 'number', ['number']);
        FPDF.CloseTextPage = PDFiumModule.cwrap('FPDFText_ClosePage', '', ['number']);
        FPDF.TextCountChars = PDFiumModule.cwrap('FPDFText_CountChars', 'number', ['number']);
        FPDF.GetUnicodeChar = PDFiumModule.cwrap('FPDFText_GetUnicode', 'number', ['number']);
        FPDF.GetCharBox = PDFiumModule.cwrap('FPDFText_GetCharBox', 'number', ['number', 'number', 'number', 'number', 'number']);
        FPDF.GetPageRotation = PDFiumModule.cwrap('FPDFPage_GetRotation', 'number', ['number']);
        FPDF.GetCharAngle = PDFiumModule.cwrap('FPDFText_GetCharAngle', 'number', ['number']);
        FPDF.TextFindStart = PDFiumModule.cwrap('FPDFText_FindStart', '', ['number', 'number', 'number', 'number']);
        FPDF.TextFindClose = PDFiumModule.cwrap('FPDFText_FindClose', '', ['number']);
        FPDF.TextFindNext = PDFiumModule.cwrap('FPDFText_FindNext', '', ['number']);
        FPDF.TextFindResultIndex = PDFiumModule.cwrap('FPDFText_GetSchResultIndex', '', ['number']);
        FPDF.TextFindCount = PDFiumModule.cwrap('FPDFText_GetSchCount', '', ['number']);
        FPDF.GetPageHeight = PDFiumModule.cwrap('FPDF_GetPageHeight', 'number', ['number']);
        FPDF.GetPageHeight = PDFiumModule.cwrap('FPDF_GetPageHeight', 'number', ['number']);
        FPDF.GetPageWidth = PDFiumModule.cwrap('FPDF_GetPageWidth', 'number', ['number']);
        pdfiumWindow.heap = (J, s) => {
            let E;
            switch (J) {
                case Int8Array:
                    E = PDFiumModule.HEAP8;
                    break;
                case Int16Array:
                    E = PDFiumModule.HEAP16;
                    break;
                case Int32Array:
                    E = PDFiumModule.HEAP32;
                    break;
                case Uint8Array:
                    E = PDFiumModule.HEAPU8;
                    break;
                case Uint16Array:
                    E = PDFiumModule.HEAPU16;
                    break;
                case Uint32Array:
                    E = PDFiumModule.HEAPU32;
                    break;
                case Float32Array:
                    E = PDFiumModule.HEAPF32;
                    break;
                case Float64Array:
                    E = PDFiumModule.HEAPF64;
                    break;
            }
            const Z = J.BYTES_PER_ELEMENT;
            const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                ? PDFiumModule.asm.malloc
                : PDFiumModule._malloc;
            const m = mallocFunction(s * Z);
            const a = Array(1 + s);
            const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                ? PDFiumModule.asm.free
                : PDFiumModule._free;
            a[0] = ({ s, J, Z, E, m, free: () => freeFunction(m) });
            for (let i = 0; i < s; i++) {
                a[i + 1] = ({ p: m + (i * Z), get v() { return E[m / Z + i]; } });
            }
            return a;
        };
    }
    /**
     *@returns {void}
     */
    function checkIfEverythingWasLoaded() {
        pageLoaded = true;
        if (pageLoaded || moduleLoaded) {
            startApp();
        }
    }
    PDFiumModule.onRuntimeInitialized = function () {
        moduleLoaded = true;
        checkIfEverythingWasLoaded();
    };
    /**
     *@returns {void}
     */
    function startApp() {
        initializeFPDF();
        if (pdfiumWindow.loaded) {
            pdfiumWindow.loaded();
        }
    }
    pdfiumWindow.onload = function () {
        pageLoaded = true;
        checkIfEverythingWasLoaded();
    };
    pdfiumWindow.loaded = function () {
        ctx.postMessage({ message: 'loaded' });
    };
    const ctx = self;
    ctx.onmessage = function (event) {
        if (event.data.message === 'initialLoading') {
            importScripts(event.data.url + '/pdfium.js');
            PDFiumModule.url = event.data.url;
            PDFiumModule.onRuntimeInitialized = function () {
                moduleLoaded = true;
                checkIfEverythingWasLoaded();
                if (event.data.fonts && Object.keys(event.data.fonts).length > 0) {
                    const filePath = '/usr/share/fonts/';
                    if (PDFiumModule.FS && PDFiumModule.FS.createPath) {
                        PDFiumModule.FS.createPath('/', filePath, true, true);
                    }
                    else {
                        PDFiumModule.FS_createPath('/', filePath, true, true);
                    }
                    for (const key in event.data.fonts) {
                        if (event.data.fonts[`${key}`] && key.indexOf('fallbackfonts') === -1) {
                            if (PDFiumModule.FS && PDFiumModule.FS.createDataFile) {
                                PDFiumModule.FS.createDataFile(filePath + key, null, event.data.fonts[`${key}`], true, true, true);
                            }
                            else {
                                PDFiumModule.FS_createDataFile(filePath + key, null, event.data.fonts[`${key}`], true, true, true);
                            }
                        }
                    }
                }
            };
            this['PDFiumModule'](PDFiumModule);
        }
        else if (event.data.message === 'LoadPageCollection') {
            if (documentDetails && event.data.skipOnReload) {
                const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                    ? PDFiumModule.asm.free
                    : PDFiumModule._free;
                freeFunction(documentDetails.processor.wasmData.wasmBuffer);
                FPDF.CloseDocument(documentDetails.processor.wasmData.wasm);
                FPDF.DestroyLibrary();
                if (PDFiumModule.removeFunction && readBlockPtr) {
                    PDFiumModule.removeFunction(readBlockPtr);
                }
                documentDetails = null;
            }
            pdfiumWindow.fileByteArray = event.data.uploadedFile;
            const fileSize = pdfiumWindow.fileByteArray.length;
            FPDF.Init();
            if (PDFiumModule.asm && PDFiumModule.asm.malloc) {
                const wasmBuffer = PDFiumModule.asm.malloc(fileSize);
                PDFiumModule.HEAPU8.set(pdfiumWindow.fileByteArray, wasmBuffer);
                pdfiumWindow.fileByteArray = null;
                documentDetails = new DocumentInfo({
                    wasm: FPDF.LoadMemDocument(wasmBuffer, fileSize, event.data.password),
                    wasmBuffer: wasmBuffer
                });
            }
            else {
                const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                    ? PDFiumModule.asm.malloc
                    : PDFiumModule._malloc;
                const wasmBuffer = mallocFunction(fileSize);
                // create a custom loader for progressive loading
                const loader = createPDFCustomLoader(event.data.uploadedFile);
                // register the readBlock function in the wasm table
                readBlockPtr = PDFiumModule.addFunction((param, position, pBuf, size) => {
                    return loader.readBlock(position, pBuf, size);
                }, 'iiiii');
                const structSize = 12;
                const ptr = mallocFunction(structSize);
                const FPDF_FILEACCESS = {
                    mFileLen: loader.getFileSize(),
                    mGetBlock: readBlockPtr,
                    mParam: null
                };
                PDFiumModule.setValue(ptr, FPDF_FILEACCESS.mFileLen, 'i32');
                PDFiumModule.setValue(ptr + 4, FPDF_FILEACCESS.mGetBlock, '*');
                PDFiumModule.setValue(ptr + 8, FPDF_FILEACCESS.mParam ? FPDF_FILEACCESS.mParam : 0, '*');
                // console.log('Loading PDF document using custom loader...');
                // load the document using the custom loader
                const docHandle = FPDF.LoadCustomDocument(ptr, event.data.password);
                documentDetails = new DocumentInfo({
                    wasm: docHandle,
                    wasmBuffer: wasmBuffer
                });
            }
            const pages = FPDF.GetPageCount(documentDetails.processor.wasmData.wasm);
            documentDetails.setPages(pages);
            documentDetails.createAllPages();
            pdfiumWindow.fileByteArray = null;
            ctx.postMessage({ message: 'PageLoaded', pageIndex: event.data.pageIndex, isZoomMode: event.data.isZoomMode, pageCount: pages, pageSizes: documentDetails.pageSizes, pageRotation: documentDetails.pageRotation });
        }
        else if (event.data.message === 'LoadPageStampCollection') {
            const fileSize = event.data.uploadedFile.length;
            FPDF.Init();
            const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                ? PDFiumModule.asm.malloc
                : PDFiumModule._malloc;
            const wasmBuffer = mallocFunction(fileSize);
            PDFiumModule.HEAPU8.set(event.data.uploadedFile, wasmBuffer);
            const documentDetailsNew = new DocumentInfo({
                wasm: FPDF.LoadMemDocument(wasmBuffer, fileSize, event.data.password),
                wasmBuffer: wasmBuffer
            });
            const pages = FPDF.GetPageCount(documentDetailsNew.processor.wasmData.wasm);
            documentDetailsNew.setPages(pages);
            documentDetailsNew.createAllPages();
            const firstPage = documentDetailsNew.getPage(event.data.pageIndex);
            const ImageData = event.data;
            const data = firstPage.render(null, ImageData.zoomFactor, false, null, null, null, true);
            data.message = 'LoadedStamp';
            data.annotName = event.data.AnnotName;
            data.rubberStampAnnotationPageNumber = event.data.rubberStampAnnotationPageNumber;
            data.annotationOrder = event.data.annotationOrder;
            data.collectionOrder = event.data.collectionOrder;
            data.isFormField = event.data.isFormField;
            if (data.isFormField) {
                data.message = 'LoadedStampForFormFields';
                data.formFieldName = event.data.formFieldName;
                data.formFieldList = event.data.formFieldList;
                data.formFields = event.data.rubberStampAnnotation;
                data.PageIndex = event.data.PageIndex;
            }
            ctx.postMessage(data);
        }
        if (documentDetails) {
            if (event.data.message === 'renderPage') {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const ImageData = event.data;
                const data = firstPage.render(null, ImageData.zoomFactor, ImageData.isTextNeed, null, null, ImageData.textDetailsId, null, event.data.cropBoxRect, event.data.mediaBoxRect);
                ctx.postMessage(data);
            }
            else if (event.data.message === 'renderPageSearch') {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const ImageData = event.data;
                const data = firstPage.render(null, ImageData.zoomFactor, ImageData.isTextNeed, null, null, ImageData.textDetailsId, null, event.data.cropBoxRect);
                data.message = 'imageRenderedSearch';
                ctx.postMessage(data);
            }
            else if (event.data.message.indexOf('extractText') !== -1) {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const ImageData = event.data;
                const isSkipCharacterBounds = event.data.isSkipCharacterBounds;
                const data = firstPage.render('extractText', ImageData.zoomFactor, ImageData.isTextNeed, null, null, ImageData.textDetailsId, null, null, null, null, isSkipCharacterBounds);
                data.message = event.data.message;
                data.isLayout = event.data.isLayout;
                data.isRenderText = event.data.isRenderText;
                data.jsonObject = event.data.jsonObject;
                data.requestType = event.data.requestType;
                data.annotationObject = event.data.annotationObject;
                data.pageIndex = event.data.pageIndex;
                data.options = event.data.options;
                data.isAPI = event.data.isAPI;
                data.isNeedToRender = event.data.isNeedToRender;
                ctx.postMessage(data);
            }
            else if (event.data.message === 'searchText') {
                const pagesCount = FPDF.GetPageCount(documentDetails.processor.wasmData.wasm);
                const searchTerm = event.data.searchWord;
                const buffer = new Uint16Array(searchTerm.length + 1);
                for (let i = 0; i < searchTerm.length; i++) {
                    buffer[parseInt(i.toString(), 10)] = searchTerm.charCodeAt(i);
                }
                buffer[searchTerm.length] = 0;
                const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                    ? PDFiumModule.asm.malloc
                    : PDFiumModule._malloc;
                const pointer = mallocFunction(buffer.length * buffer.BYTES_PER_ELEMENT);
                PDFiumModule.HEAPU16.set(buffer, pointer / Uint16Array.BYTES_PER_ELEMENT);
                let occurrencesCount = 0;
                const isMatchCase = (event.data.matchCase === true) ? 1 : 0;
                const startIndex = event.data.startIndex;
                const endIndex = event.data.endIndex;
                let pageSearchCounts = {};
                for (let a = startIndex; a < endIndex; a++) {
                    let pageOccurrence = -1;
                    const page = FPDF.LoadPage(documentDetails.processor.wasmData.wasm, a);
                    const textPage = FPDF.LoadTextPage(page);
                    const searchHandle = FPDF.TextFindStart(textPage, pointer, isMatchCase, 0);
                    const pageHeight = FPDF.GetPageHeight(page);
                    while (FPDF.TextFindNext(searchHandle)) {
                        occurrencesCount++;
                        pageOccurrence++;
                        const charLength = FPDF.TextFindCount(searchHandle);
                        const startIndex = FPDF.TextFindResultIndex(searchHandle);
                        if (!pageSearchCounts[parseInt(a.toString(), 10)]) {
                            pageSearchCounts[parseInt(a.toString(), 10)] = { Indices: [], Bounds: {}, PageOccurrence: 0 };
                        }
                        if (!pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)]) {
                            pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)] = [];
                        }
                        pageSearchCounts[parseInt(a.toString(), 10)].Indices.push(startIndex);
                        let charLeft = Number.POSITIVE_INFINITY;
                        let charRight = 0;
                        let charBottom = Number.POSITIVE_INFINITY;
                        let charTop = 0;
                        for (let i = 0; i < charLength; i++) {
                            const resultPage = FPDF.GetUnicodeChar(textPage, startIndex + i);
                            const character = String.fromCharCode(resultPage);
                            if (character !== '\r') {
                                if (character !== '\n') {
                                    const result = H(F64, 4, [-1, -1, -1, -1])((left, right, bottom, top) => {
                                        return FPDF.GetCharBox(textPage, startIndex + i, left, right, bottom, top);
                                    });
                                    charLeft = Math.min(charLeft, result[0]);
                                    charRight = Math.max(charRight, result[1]);
                                    charBottom = Math.min(charBottom, result[2]);
                                    charTop = Math.max(charTop, result[3]);
                                }
                            }
                            if (character === '\r') {
                                const characterBounds = new RectAngle((charLeft * (96 / 72)), ((pageHeight - (charTop - charBottom) - charBottom) * (96 / 72)), ((charRight - charLeft) * (96 / 72)), ((charTop - charBottom) * (96 / 72)), '', null);
                                pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)]
                                    .push(characterBounds);
                                pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)].sort((a, b) => {
                                    return a.Top === b.Top ? a.Left - b.Left : a.Top - b.Top;
                                });
                                charLeft = Number.POSITIVE_INFINITY;
                                charRight = 0;
                                charBottom = Number.POSITIVE_INFINITY;
                                charTop = 0;
                            }
                        }
                        const characterBounds = new RectAngle((charLeft * (96 / 72)), ((pageHeight - (charTop - charBottom) - charBottom) * (96 / 72)), ((charRight - charLeft) * (96 / 72)), ((charTop - charBottom) * (96 / 72)), '', null);
                        pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)].push(characterBounds);
                        pageSearchCounts[parseInt(a.toString(), 10)].Bounds[parseInt(pageOccurrence.toString(), 10)].sort((a, b) => {
                            return a.Top === b.Top ? a.Left - b.Left : a.Top - b.Top;
                        });
                        pageSearchCounts[parseInt(a.toString(), 10)].PageOccurrence = pageOccurrence + 1;
                    }
                    FPDF.TextFindClose(searchHandle);
                    FPDF.ClosePage(page);
                }
                const result = {
                    totalSearchCount: occurrencesCount,
                    resultPages: pageSearchCounts,
                    message: 'textSearched',
                    searchWord: searchTerm,
                    matchCase: event.data.matchCase,
                    isRequestsend: event.data.isRequestsend,
                    isCompletedSearch: (endIndex === pagesCount) ? true : false,
                    endIndex: endIndex
                };
                ctx.postMessage(result);
                pageSearchCounts = {};
                const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                    ? PDFiumModule.asm.free
                    : PDFiumModule._free;
                freeFunction(pointer);
            }
            else if (event.data.message === 'renderThumbnail') {
                // eslint-disable-next-line
                const thumbnail = new Promise((resolve, reject) => {
                    try {
                        const firstPage = documentDetails.getPage(event.data.pageIndex);
                        if (firstPage.processor !== null && firstPage.processor !== undefined) {
                            const data = firstPage.render('thumbnail', null, event.data.isTextNeed, null, null, null, null, null, null, null, event.data.isSkipCharacterBounds, event.data.imageSize);
                            data.isRenderText = event.data.isRenderText;
                            data.jsonObject = event.data.jsonObject;
                            data.requestType = event.data.requestType;
                            resolve(data);
                        }
                    }
                    catch (error) {
                        reject(error);
                    }
                });
                thumbnail.then((results) => {
                    ctx.postMessage(results);
                });
            }
            else if (event.data.message === 'renderPreviewTileImage') {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const data = firstPage.render('thumbnail', null, event.data.isTextNeed, null, null, null, null, null, null, null, event.data.isSkipCharacterBounds, event.data.imageSize);
                data.message = 'renderPreviewTileImage';
                data.isRenderText = event.data.isRenderText;
                data.jsonObject = event.data.jsonObject;
                data.requestType = event.data.requestType;
                data.startIndex = event.data.startIndex;
                data.endIndex = event.data.endIndex;
                data.imageSize = event.data.imageSize;
                data.initialLoad = event.data.initialLoad;
                ctx.postMessage(data);
            }
            else if (event.data.message === 'printImage') {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const data = firstPage.render('print', null, false, event.data.printScaleFactor, event.data.printDevicePixelRatio);
                ctx.postMessage(data);
            }
            else if (event.data.message === 'extractImage' || event.data.message === 'extractImages') {
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const ImageData = event.data;
                const data = firstPage.render(null, ImageData.zoomFactor, ImageData.isTextNeed, null, null, ImageData.textDetailsId, null, null, null, event.data.size);
                if (event.data.message === 'extractImage') {
                    data.message = 'imageExtracted';
                }
                if (event.data.message === 'extractImages') {
                    data.message = 'imagesExtracted';
                }
                ctx.postMessage(data);
            }
            else if (event.data.message === 'renderImageAsTile') {
                const values = event.data;
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const data = firstPage.renderTileImage(values.tileX, values.tileY, values.tileXCount, values.tileYCount, values.zoomFactor, event.data.isTextNeed, event.data.textDetailsId, event.data.cropBoxRect, event.data.mediaBoxRect);
                ctx.postMessage(data);
            }
            else if (event.data.message === 'renderImageAsTileSearch') {
                const values = event.data;
                const firstPage = documentDetails.getPage(event.data.pageIndex);
                const data = firstPage.renderTileImage(values.tileX, values.tileY, values.tileXCount, values.tileYCount, values.zoomFactor, event.data.isTextNeed, event.data.textDetailsId, event.data.cropBoxRect, event.data.mediaBoxRect);
                data.message = 'renderTileImageSearch';
                ctx.postMessage(data);
            }
            else if (event.data.message === 'unloadFPDF') {
                if (documentDetails) {
                    const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                        ? PDFiumModule.asm.free
                        : PDFiumModule._free;
                    freeFunction(documentDetails.processor.wasmData.wasmBuffer);
                    FPDF.CloseDocument(documentDetails.processor.wasmData.wasm);
                    FPDF.DestroyLibrary();
                    if (PDFiumModule.removeFunction && readBlockPtr) {
                        PDFiumModule.removeFunction(readBlockPtr);
                    }
                    documentDetails = null;
                }
            }
        }
        if (event.data.message === 'unloadFPDF') {
            ctx.postMessage({ message: '' });
        }
    };
    /**
     * @param {any} data - jsonObject
     * @returns {any} - any
     */
    function createPDFCustomLoader(data) {
        return {
            getFileSize: () => data.length,
            readBlock: (offset, buffer, length) => {
                if (offset + length > data.length) {
                    console.error('Requested chunk is out of bounds');
                    return 0; // Return zero for error if out of bounds
                }
                for (let i = 0; i < length; i++) {
                    PDFiumModule.HEAPU8[buffer + i] = data[offset + i];
                }
                return 1;
            }
        };
    }
    class Page {
        constructor(index, processor) {
            this.index = index;
            this.src = null;
            this.processor = processor;
        }
        render(message, zoomFactor, isTextNeed, printScaleFactor, printDevicePixelRatio, textDetailsId, isTransparent, cropBoxRect, mediaBoxRect, size, isSkipCharacterBounds, imageSize) {
            return this.processor.render(this.index, message, zoomFactor, isTextNeed, printScaleFactor, printDevicePixelRatio, textDetailsId, isTransparent, cropBoxRect, mediaBoxRect, size, isSkipCharacterBounds, imageSize);
        }
        renderTileImage(x, y, tileX, tileY, zoomFactor, isTextNeed, textDetailsId, cropBoxRect, mediaBoxRect) {
            return this.processor.renderTileImage(this.index, x, y, tileX, tileY, zoomFactor, isTextNeed, textDetailsId, cropBoxRect, mediaBoxRect);
        }
    }
    class RectAngle {
        constructor(X, Y, Width, Height, Text, Rotation) {
            this.X = X;
            this.Y = Y;
            this.Width = Width;
            this.Height = Height;
            this.Bottom = this.Y + this.Height;
            this.Right = this.X + this.Width;
            this.Top = this.Y;
            this.Left = this.X;
            this.Rotation = Rotation;
            this.Text = Text;
        }
    }
    class Processor {
        constructor(wasmData) {
            this.TextBounds = [];
            this.TextContent = [];
            this.CharacterBounds = [];
            this.PageText = '';
            this.wasmData = wasmData;
        }
        getPageSize(i = 0) {
            return H(F64, 2, [-1, -1])((w, h) => FPDF.GetPageSizeByIndex(this.wasmData.wasm, i, w, h)).
                map((v) => parseInt((v * (96 / 72)).toString(), 10));
        }
        getCharBounds(pagePointer, i = 0) {
            return H(F64, 4, [-1, -1, -1, -1])((left, right, bottom, top) => FPDF.
                GetCharBox(pagePointer, i, left, right, bottom, top));
        }
        getRender(i = 0, w, h, isTextNeed, isTransparent, cropBoxRect, mediaBoxRect, isSkipCharacterBounds) {
            const flag = FPDF.REVERSE_BYTE_ORDER;
            const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                ? PDFiumModule.asm.malloc
                : PDFiumModule._malloc;
            const heap = mallocFunction(w * h * 4);
            PDFiumModule.HEAPU8.fill(0, heap, heap + (w * h * 4));
            const bmap = FPDF.Bitmap_CreateEx(w, h, FPDF.Bitmap_BGRA, heap, w * 4);
            const page = FPDF.LoadPage(this.wasmData.wasm, i);
            FPDF.Bitmap_FillRect(bmap, 0, 0, w, h, isTransparent ? 0x00FFFFFF : 0xFFFFFFFF);
            FPDF.RenderPageBitmap(bmap, page, 0, 0, w, h, 0, flag);
            FPDF.Bitmap_Destroy(bmap);
            this.textExtraction(page, i, isTextNeed, cropBoxRect, mediaBoxRect, isSkipCharacterBounds);
            FPDF.ClosePage(page);
            return heap;
        }
        textExtraction(pagePointer, pageIndex, isTextNeed, cropBoxRect, mediaBoxRect, isSkipCharacterBounds) {
            if (isTextNeed) {
                // eslint-disable-next-line
                let [pageWidth, pageHeight] = this.getPageSize(pageIndex);
                if (mediaBoxRect && cropBoxRect && mediaBoxRect.y && cropBoxRect.y && mediaBoxRect.y !== cropBoxRect.y) {
                    pageHeight = pageHeight + this.pointerToPixelConverter(mediaBoxRect && mediaBoxRect.y ? mediaBoxRect.y : 0);
                }
                const textPage = FPDF.LoadTextPage(pagePointer);
                const pageRotation = FPDF.GetPageRotation(pagePointer);
                const totalCharacterCount = FPDF.TextCountChars(textPage);
                this.TextBounds = [];
                this.TextContent = [];
                this.CharacterBounds = [];
                let pageText = '';
                let minTop = 0;
                let maxBottom = 0;
                let minLeft = 0;
                let maxRight = 0;
                let top = [];
                let bottom = [];
                let left = [];
                let right = [];
                let wordBounds = [];
                let word = '';
                let wordMinLeft = 0;
                let wordMaxRight = 0;
                let wordMinTop = 0;
                let wordMaxBottom = 0;
                let wordRotation = 0;
                let wordStart = true;
                let isZeroWidthSpace = false;
                let isPreviousSpace = false;
                let startNewLine = false;
                const maximumSpaceForNewLine = 11;
                for (let charCount = 0; charCount <= totalCharacterCount; charCount++) {
                    if (!isSkipCharacterBounds) {
                        const result = FPDF.GetUnicodeChar(textPage, charCount);
                        let rotationRadian = FPDF.GetCharAngle(textPage, charCount);
                        const character = String.fromCharCode(result);
                        let [charLeft, charRight, charBottom, charTop] = this.getCharBounds(textPage, charCount);
                        let X = this.pointerToPixelConverter(charLeft) -
                            this.pointerToPixelConverter(cropBoxRect && cropBoxRect.x ? cropBoxRect.x : 0);
                        let Y = (pageHeight + this.pointerToPixelConverter(cropBoxRect && cropBoxRect.y ? cropBoxRect.y : 0)) -
                            this.pointerToPixelConverter(charTop);
                        let Width = this.pointerToPixelConverter(charRight - charLeft);
                        let Height = this.pointerToPixelConverter(charTop - charBottom);
                        let rotationAngle = parseInt((rotationRadian * 180 / Math.PI).toString(), 10);
                        if (charCount < totalCharacterCount) {
                            pageText += character;
                            if (rotationAngle === 270 && pageRotation === 1) {
                                const newX = this.pointerToPixelConverter(charBottom) -
                                    this.pointerToPixelConverter(cropBoxRect && cropBoxRect.x ? cropBoxRect.x : 0);
                                const newY = this.pointerToPixelConverter(charLeft);
                                Height = this.pointerToPixelConverter(Height);
                                const currentCharacterBounds = new RectAngle(newX, newY, Width, Height, character, rotationAngle);
                                this.CharacterBounds.push(currentCharacterBounds);
                            }
                            else {
                                const currentCharacterBounds = new RectAngle(X, Y, Width, Height, character, rotationAngle);
                                this.CharacterBounds.push(currentCharacterBounds);
                            }
                        }
                        if (pageRotation === 1 || pageRotation === 3) {
                            Y = (pageWidth) - this.pointerToPixelConverter(charTop);
                        }
                        switch (character) {
                            case '\0': {
                                // eslint-disable-next-line
                                minTop = Math.min.apply(Math, top);
                                // eslint-disable-next-line
                                maxBottom = Math.max.apply(Math, bottom);
                                // eslint-disable-next-line
                                minLeft = Math.min.apply(Math, left);
                                // eslint-disable-next-line
                                maxRight = Math.max.apply(Math, right);
                                const newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                wordBounds.push(newWordBounds);
                                this.textBoundsCalculation(wordBounds, minTop, maxBottom, maxRight, minLeft, pageRotation, pageWidth, pageHeight, totalCharacterCount);
                                wordBounds = [];
                                wordStart = true;
                                isPreviousSpace = false;
                                word = '';
                                top = [];
                                left = [];
                                bottom = [];
                                right = [];
                                minTop = 0;
                                maxBottom = 0;
                                minLeft = 0;
                                maxRight = 0;
                                break;
                            }
                            case '\r':
                                if (charCount < totalCharacterCount) {
                                    const characterBounds = new RectAngle(X, Y, Width, Height, '\r\n', rotationAngle);
                                    top.push(characterBounds.Top);
                                    bottom.push(characterBounds.Bottom);
                                    left.push(characterBounds.Left);
                                    right.push(characterBounds.Right);
                                    // eslint-disable-next-line
                                    minTop = Math.min.apply(Math, top);
                                    // eslint-disable-next-line
                                    maxBottom = Math.max.apply(Math, bottom);
                                    // eslint-disable-next-line
                                    minLeft = Math.min.apply(Math, left);
                                    // eslint-disable-next-line
                                    maxRight = Math.max.apply(Math, right);
                                    let newWordBounds;
                                    if (wordStart === false) {
                                        newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                        wordBounds.push(newWordBounds);
                                    }
                                    wordBounds.push(characterBounds);
                                    this.textBoundsCalculation(wordBounds, minTop, maxBottom, maxRight, minLeft, pageRotation, pageWidth, pageHeight, totalCharacterCount);
                                    wordBounds = [];
                                    wordStart = true;
                                    isPreviousSpace = false;
                                    word = '';
                                    top = [];
                                    left = [];
                                    bottom = [];
                                    right = [];
                                    minTop = 0;
                                    maxBottom = 0;
                                    minLeft = 0;
                                    maxRight = 0;
                                    pageText += '\n';
                                    rotationRadian = FPDF.GetCharAngle(textPage, charCount);
                                    [charLeft, charRight, charBottom, charTop] = this.getCharBounds(textPage, charCount);
                                    X = this.pointerToPixelConverter(charLeft);
                                    Y = (pageHeight) - this.pointerToPixelConverter(charTop);
                                    Width = this.pointerToPixelConverter(charRight - charLeft);
                                    Height = this.pointerToPixelConverter(charTop - charBottom);
                                    rotationAngle = parseInt((rotationRadian * 180 / Math.PI).toString(), 10);
                                    const currentCharacterBounds = new RectAngle(X, Y, Width, Height, character, rotationAngle);
                                    this.CharacterBounds.push(currentCharacterBounds);
                                    charCount++;
                                }
                                break;
                            case '\u0002':
                            case '\ufffe':
                                {
                                    const characterBounds = new RectAngle(X, Y, Width, Height, character, rotationAngle);
                                    top.push(characterBounds.Top);
                                    bottom.push(characterBounds.Bottom);
                                    left.push(characterBounds.Left);
                                    right.push(characterBounds.Right);
                                    // eslint-disable-next-line
                                    minTop = Math.min.apply(Math, top);
                                    // eslint-disable-next-line
                                    maxBottom = Math.max.apply(Math, bottom);
                                    // eslint-disable-next-line
                                    minLeft = Math.min.apply(Math, left);
                                    // eslint-disable-next-line
                                    maxRight = Math.max.apply(Math, right);
                                    let newWordBounds;
                                    if (wordStart === false) {
                                        newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                        wordBounds.push(newWordBounds);
                                    }
                                    if (character === '\u0002') {
                                        wordBounds.push(characterBounds);
                                    }
                                    this.textBoundsCalculation(wordBounds, minTop, maxBottom, maxRight, minLeft, pageRotation, pageWidth, pageHeight, totalCharacterCount);
                                    wordBounds = [];
                                    wordStart = true;
                                    isPreviousSpace = false;
                                    word = '';
                                    top = [];
                                    left = [];
                                    bottom = [];
                                    right = [];
                                    minTop = 0;
                                    maxBottom = 0;
                                    minLeft = 0;
                                    maxRight = 0;
                                }
                                break;
                            default:
                                if (Width === 0 || Height === 0) {
                                    isZeroWidthSpace = true;
                                    // eslint-disable-next-line
                                    minTop = Math.min.apply(Math, top);
                                    // eslint-disable-next-line
                                    maxBottom = Math.max.apply(Math, bottom);
                                    // eslint-disable-next-line
                                    minLeft = Math.min.apply(Math, left);
                                    // eslint-disable-next-line
                                    maxRight = Math.max.apply(Math, right);
                                    let newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                    wordBounds.push(newWordBounds);
                                    const characterBounds = new RectAngle(X, Y, Width, Height, character, rotationAngle);
                                    wordMinTop = characterBounds.Top;
                                    wordMaxBottom = characterBounds.Bottom;
                                    wordMinLeft = characterBounds.Left;
                                    wordMaxRight = characterBounds.Right;
                                    word = character;
                                    wordRotation = wordBounds[wordBounds.length - 1].Rotation;
                                    newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                    wordBounds.push(newWordBounds);
                                    wordMinTop = 0;
                                    wordMaxBottom = 0;
                                    wordMinLeft = 0;
                                    wordMaxRight = 0;
                                    word = '';
                                    wordRotation = 0;
                                    wordStart = true;
                                    isPreviousSpace = true;
                                }
                                else {
                                    if (wordStart === true) {
                                        wordMinTop = Y;
                                        wordMaxBottom = Y + Height;
                                        wordMinLeft = X;
                                        wordMaxRight = X + Width;
                                    }
                                    const characterBounds = new RectAngle(X, Y, Width, Height, character, rotationAngle);
                                    if (character !== ' ') {
                                        if (isPreviousSpace && wordBounds.length > 0 && (rotationAngle === wordBounds[0].Rotation)) {
                                            if ((rotationAngle === 180 || rotationAngle === 0) &&
                                                (Math.abs(characterBounds.Y - wordBounds[0].Y) > maximumSpaceForNewLine)) {
                                                startNewLine = true;
                                            }
                                            if ((rotationAngle === 270 || rotationAngle === 90) &&
                                                (Math.abs(characterBounds.X - wordBounds[0].X) > maximumSpaceForNewLine)) {
                                                startNewLine = true;
                                            }
                                        }
                                        if ((isZeroWidthSpace && wordBounds.length >= 1 &&
                                            wordBounds[wordBounds.length - 1].Rotation !== characterBounds.Rotation) || startNewLine) {
                                            isZeroWidthSpace = false;
                                            startNewLine = false;
                                            // eslint-disable-next-line
                                            minTop = Math.min.apply(Math, top);
                                            // eslint-disable-next-line
                                            maxBottom = Math.max.apply(Math, bottom);
                                            // eslint-disable-next-line
                                            minLeft = Math.min.apply(Math, left);
                                            // eslint-disable-next-line
                                            maxRight = Math.max.apply(Math, right);
                                            let newWordBounds;
                                            if (wordStart === false) {
                                                newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                                wordBounds.push(newWordBounds);
                                            }
                                            this.textBoundsCalculation(wordBounds, minTop, maxBottom, maxRight, minLeft, pageRotation, pageWidth, pageHeight, totalCharacterCount);
                                            wordBounds = [];
                                            wordStart = true;
                                            word = '';
                                            top = [];
                                            left = [];
                                            bottom = [];
                                            right = [];
                                            minTop = 0;
                                            maxBottom = 0;
                                            minLeft = 0;
                                            maxRight = 0;
                                        }
                                        top.push(characterBounds.Top);
                                        bottom.push(characterBounds.Bottom);
                                        left.push(characterBounds.Left);
                                        right.push(characterBounds.Right);
                                        wordMinTop = Math.min(wordMinTop, characterBounds.Top);
                                        wordMaxBottom = Math.max(wordMaxBottom, characterBounds.Bottom);
                                        wordMinLeft = Math.min(wordMinLeft, characterBounds.Left);
                                        wordMaxRight = Math.max(wordMaxRight, characterBounds.Right);
                                        word += character;
                                        wordRotation = characterBounds.Rotation;
                                        wordStart = false;
                                        isPreviousSpace = false;
                                    }
                                    else {
                                        let newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                        wordBounds.push(newWordBounds);
                                        wordMinTop = characterBounds.Top;
                                        wordMaxBottom = characterBounds.Bottom;
                                        wordMinLeft = characterBounds.Left;
                                        wordMaxRight = characterBounds.Right;
                                        word = character;
                                        wordRotation = characterBounds.Rotation;
                                        newWordBounds = new RectAngle(wordMinLeft, wordMinTop, wordMaxRight - wordMinLeft, wordMaxBottom - wordMinTop, word, wordRotation);
                                        wordBounds.push(newWordBounds);
                                        wordMinTop = 0;
                                        wordMaxBottom = 0;
                                        wordMinLeft = 0;
                                        wordMaxRight = 0;
                                        word = '';
                                        wordRotation = 0;
                                        wordStart = true;
                                        isPreviousSpace = true;
                                    }
                                }
                                break;
                        }
                    }
                    else {
                        const result = FPDF.GetUnicodeChar(textPage, charCount);
                        const character = String.fromCharCode(result);
                        if (charCount < totalCharacterCount) {
                            pageText += character;
                        }
                    }
                }
                FPDF.CloseTextPage(textPage);
                this.Rotation = pageRotation;
                this.PageText = pageText;
            }
        }
        pointerToPixelConverter(pointerValue) {
            return (pointerValue * (96 / 72));
        }
        textBoundsCalculation(wordBounds, minTop, maxBottom, maxRight, minLeft, pageRotation, pageWidth, pageHeight, totalCharacterCount) {
            let newWordBounds;
            let hasInBetweenRotation = false;
            let inBetweenRotatedText = '';
            const maximumSpaceBetweenWords = 30;
            const minimumSpaceBetweenWords = 5;
            const sentence = wordBounds.reduce((word, rect) => word + rect.Text, '');
            const isRTLText = this.checkIsRtlText(sentence);
            if (totalCharacterCount >= 5000) {
                const newWordBoundsCollection = [];
                let k = 0;
                const updateBounds = (rect, bounds) => {
                    bounds.minX = Math.min(bounds.minX, rect.X);
                    bounds.minY = Math.min(bounds.minY, rect.Y);
                    bounds.maxX = Math.max(bounds.maxX, rect.X + rect.Width);
                    bounds.maxY = Math.max(bounds.maxY, rect.Y + rect.Height);
                };
                const getMostFrequentLineHeight = (lineHeights, defaultHeight) => {
                    return lineHeights.sort((a, b) => lineHeights.filter((v) => v === a).length - lineHeights.filter((v) => v === b).length).pop() || defaultHeight;
                };
                for (let i = 0; i < wordBounds.length; i++) {
                    let diff = 0;
                    if (i < wordBounds.length - 1) {
                        diff = wordBounds[parseInt((i + 1).toString(), 10)].Left - wordBounds[parseInt(i.toString(), 10)].Right;
                    }
                    if (diff >= minimumSpaceBetweenWords && wordBounds[parseInt(i.toString(), 10)].Text !== '\r\n') {
                        const bounds = {
                            minX: wordBounds[parseInt(k.toString(), 10)].X,
                            minY: wordBounds[parseInt(k.toString(), 10)].Y,
                            maxX: wordBounds[parseInt(k.toString(), 10)].X,
                            maxY: wordBounds[parseInt(k.toString(), 10)].Y
                        };
                        let inBetweenRotatedText = '';
                        const lineHeights = [];
                        for (let j = k; j <= i; j++) {
                            const rect = wordBounds[parseInt(j.toString(), 10)];
                            updateBounds(rect, bounds);
                            lineHeights.push(rect.Height);
                            inBetweenRotatedText += rect.Text;
                        }
                        const combinedWidth = bounds.maxX - bounds.minX;
                        const combinedHeight = bounds.maxY - bounds.minY;
                        const newWordBounds = new RectAngle(bounds.minX, bounds.minY, combinedWidth, combinedHeight, inBetweenRotatedText, wordBounds[0].Rotation);
                        newWordBoundsCollection.push(newWordBounds);
                        k = i + 1;
                    }
                    else if (newWordBoundsCollection.length === 0 && i === wordBounds.length - 1) {
                        const bounds = { minX: wordBounds[0].X, minY: wordBounds[0].Y, maxX: wordBounds[0].X, maxY: wordBounds[0].Y };
                        wordBounds.forEach((rect) => {
                            updateBounds(rect, bounds);
                        });
                        const combinedWidth = bounds.maxX - bounds.minX;
                        const combinedHeight = bounds.maxY - bounds.minY;
                        const inBetweenRotatedText = wordBounds.map((rect) => rect.Text).join('');
                        const newWordBounds = new RectAngle(bounds.minX, bounds.minY, combinedWidth, combinedHeight, inBetweenRotatedText, wordBounds[0].Rotation);
                        wordBounds = [newWordBounds];
                    }
                    else if (i === wordBounds.length - 1) {
                        const bounds = {
                            minX: wordBounds[parseInt(k.toString(), 10)].X,
                            minY: wordBounds[parseInt(k.toString(), 10)].Y,
                            maxX: wordBounds[parseInt(k.toString(), 10)].X,
                            maxY: wordBounds[parseInt(k.toString(), 10)].Y
                        };
                        let inBetweenRotatedText = '';
                        const lineHeights = [];
                        for (let j = k; j <= i; j++) {
                            const rect = wordBounds[parseInt(j.toString(), 10)];
                            updateBounds(rect, bounds);
                            lineHeights.push(rect.Height);
                            inBetweenRotatedText += rect.Text;
                        }
                        const combinedWidth = bounds.maxX - bounds.minX;
                        const combinedHeight = bounds.maxY - bounds.minY;
                        const newWordBounds = new RectAngle(bounds.minX, bounds.minY, combinedWidth, combinedHeight, inBetweenRotatedText, wordBounds[0].Rotation);
                        newWordBoundsCollection.push(newWordBounds);
                    }
                }
                if (newWordBoundsCollection.length > 0) {
                    wordBounds = newWordBoundsCollection;
                }
            }
            for (let count = 0; count < wordBounds.length; count++) {
                const textRotation = wordBounds[parseInt(count.toString(), 10)].Rotation;
                if (textRotation === 0 || textRotation === 180) {
                    if (hasInBetweenRotation) {
                        this.TextBounds.push(newWordBounds);
                        this.TextContent.push(inBetweenRotatedText);
                        inBetweenRotatedText = '';
                    }
                    hasInBetweenRotation = false;
                    if (pageRotation === 0) {
                        newWordBounds = new RectAngle(wordBounds[parseInt(count.toString(), 10)].Left, minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 1) {
                        newWordBounds = new RectAngle(pageWidth - minTop, wordBounds[parseInt(count.toString(), 10)].Left, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 2) {
                        newWordBounds = new RectAngle(pageWidth - wordBounds[parseInt(count.toString(), 10)].Left, pageHeight - minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 3) {
                        newWordBounds = new RectAngle(minTop, pageHeight - wordBounds[parseInt(count.toString(), 10)].Left, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                }
                else if (textRotation === 90 || textRotation === 270) {
                    if (hasInBetweenRotation) {
                        this.TextBounds.push(newWordBounds);
                        this.TextContent.push(inBetweenRotatedText);
                        inBetweenRotatedText = '';
                    }
                    hasInBetweenRotation = false;
                    if (pageRotation === 0) {
                        newWordBounds = new RectAngle(minLeft, wordBounds[parseInt(count.toString(), 10)].Top, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 1) {
                        newWordBounds = new RectAngle(pageWidth - wordBounds[parseInt(count.toString(), 10)].Top, minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 2) {
                        newWordBounds = new RectAngle(pageWidth - minLeft, pageHeight - wordBounds[parseInt(count.toString(), 10)].Top, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 3) {
                        newWordBounds = new RectAngle(wordBounds[parseInt(count.toString(), 10)].Top, pageHeight - minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                }
                else if (!hasInBetweenRotation) {
                    hasInBetweenRotation = true;
                    inBetweenRotatedText += wordBounds[parseInt(count.toString(), 10)].Text;
                    if (pageRotation === 0) {
                        newWordBounds = new RectAngle(wordBounds[parseInt(count.toString(), 10)].Left, minTop, maxRight - minLeft, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 1) {
                        newWordBounds = new RectAngle(pageWidth - minTop, wordBounds[parseInt(count.toString(), 10)].Left, maxRight - minLeft, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 2) {
                        newWordBounds = new RectAngle(pageWidth - wordBounds[parseInt(count.toString(), 10)].Left, pageHeight - minTop, maxRight - minLeft, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                    else if (pageRotation === 3) {
                        newWordBounds = new RectAngle(minTop, pageHeight - wordBounds[parseInt(count.toString(), 10)].Left, maxRight - minLeft, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                    }
                }
                else {
                    inBetweenRotatedText += wordBounds[parseInt(count.toString(), 10)].Text;
                }
                if (!hasInBetweenRotation && wordBounds[parseInt(count.toString(), 10)].Text === ' ' && count !== 0 && count + 1 <= wordBounds.length) {
                    if (!isRTLText) {
                        if (count + 1 !== wordBounds.length) {
                            let spaceWidth = 0;
                            switch (textRotation) {
                                case 0:
                                    spaceWidth = wordBounds[count + 1].Left - (wordBounds[count - 1].Left + wordBounds[count - 1].Width);
                                    if (maximumSpaceBetweenWords < spaceWidth || spaceWidth < 0) {
                                        spaceWidth = 0;
                                    }
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(wordBounds[count - 1].Left + wordBounds[count - 1].Width, minTop, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - minTop, wordBounds[count - 1].Left + wordBounds[count - 1].Width, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Left +
                                            wordBounds[count - 1].Width), pageHeight - minTop, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle(minTop, pageHeight - (wordBounds[count - 1].Left +
                                            wordBounds[count - 1].Width), spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 90:
                                    spaceWidth = wordBounds[count + 1].Top - (wordBounds[count - 1].Top + wordBounds[count - 1].Height);
                                    if (maximumSpaceBetweenWords < spaceWidth || spaceWidth < 0) {
                                        spaceWidth = 0;
                                    }
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(minLeft, wordBounds[count - 1].Top + wordBounds[count - 1].Height, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Top +
                                            wordBounds[count - 1].Height), minLeft, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - minLeft, pageHeight - (wordBounds[count - 1].Top +
                                            wordBounds[count - 1].Height), maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle((wordBounds[count - 1].Top + wordBounds[count - 1].Height), pageHeight - minLeft, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 180:
                                    spaceWidth = wordBounds[count - 1].Left - (wordBounds[count + 1].Left + wordBounds[count + 1].Width);
                                    if (maximumSpaceBetweenWords < spaceWidth || spaceWidth < 0) {
                                        spaceWidth = 0;
                                    }
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(wordBounds[count + 1].Left + wordBounds[count + 1].Width, minTop, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - minTop, wordBounds[count + 1].Left +
                                            wordBounds[count + 1].Width, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count + 1].Left +
                                            wordBounds[count + 1].Width), pageHeight - minTop, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle(minTop, pageHeight - (wordBounds[count + 1].Left +
                                            wordBounds[count + 1].Width), spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 270:
                                    spaceWidth = wordBounds[count - 1].Top - (wordBounds[count + 1].Top + wordBounds[count + 1].Height);
                                    if (maximumSpaceBetweenWords < spaceWidth || spaceWidth < 0) {
                                        spaceWidth = 0;
                                    }
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(minLeft, wordBounds[count + 1].Top + wordBounds[count + 1].Height, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count + 1].Top +
                                            wordBounds[count + 1].Height), minLeft, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - minLeft, pageHeight -
                                            (wordBounds[count + 1].Top + wordBounds[count + 1].Height), maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle((wordBounds[count + 1].Top + wordBounds[count + 1].Height), pageHeight - minLeft, maxRight - minLeft, spaceWidth, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                            }
                        }
                        else {
                            switch (textRotation) {
                                case 90:
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(minLeft, wordBounds[count - 1].Top + wordBounds[count - 1].Height, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Top +
                                            wordBounds[count - 1].Height), minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - minLeft, pageHeight -
                                            (wordBounds[count - 1].Top + wordBounds[count - 1].Height), maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle((wordBounds[count - 1].Top + wordBounds[count - 1].Height), pageHeight - minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 270:
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(minLeft, wordBounds[count - 1].Top -
                                            wordBounds[parseInt(count.toString(), 10)].Height, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Top -
                                            wordBounds[parseInt(count.toString(), 10)].Height), minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - minLeft, pageHeight -
                                            wordBounds[count - 1].Top - wordBounds[parseInt(count.toString(), 10)].Height, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle((wordBounds[count - 1].Top -
                                            wordBounds[parseInt(count.toString(), 10)].Height), pageHeight - minLeft, maxRight - minLeft, wordBounds[parseInt(count.toString(), 10)].Height, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 180:
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(wordBounds[count - 1].Left -
                                            wordBounds[parseInt(count.toString(), 10)].Width, minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle((pageWidth - minTop), wordBounds[count - 1].Left -
                                            wordBounds[parseInt(count.toString(), 10)].Width, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Left -
                                            wordBounds[parseInt(count.toString(), 10)].Width), pageHeight - minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle(minTop, pageHeight - (wordBounds[count - 1].Left -
                                            wordBounds[parseInt(count.toString(), 10)].Width), wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                                case 0:
                                    if (pageRotation === 0) {
                                        newWordBounds = new RectAngle(wordBounds[count - 1].Left + wordBounds[count - 1].Width, minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 1) {
                                        newWordBounds = new RectAngle(pageWidth - minTop, wordBounds[count - 1].Left +
                                            wordBounds[count - 1].Width, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 2) {
                                        newWordBounds = new RectAngle(pageWidth - (wordBounds[count - 1].Left +
                                            wordBounds[count - 1].Width), pageHeight - minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    else if (pageRotation === 3) {
                                        newWordBounds = new RectAngle(minTop, pageHeight - (wordBounds[count - 1].Left +
                                            wordBounds[count - 1].Width), wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, textRotation);
                                    }
                                    break;
                            }
                        }
                    }
                    else if (isRTLText && count + 1 !== wordBounds.length) {
                        let spaceWidth = (wordBounds[count - 1].Left - (wordBounds[count + 1].Left + wordBounds[count + 1].Width));
                        if (maximumSpaceBetweenWords < spaceWidth || spaceWidth < 0) {
                            spaceWidth = 0;
                        }
                        newWordBounds = new RectAngle((wordBounds[count + 1].Left + wordBounds[count + 1].Width), minTop, spaceWidth, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, wordBounds[parseInt(count.toString(), 10)].Rotation);
                    }
                    else if (isRTLText) {
                        newWordBounds = new RectAngle((wordBounds[count - 1].Left -
                            wordBounds[parseInt(count.toString(), 10)].Width), minTop, wordBounds[parseInt(count.toString(), 10)].Width, maxBottom - minTop, wordBounds[parseInt(count.toString(), 10)].Text, wordBounds[parseInt(count.toString(), 10)].Rotation);
                    }
                }
                if (!hasInBetweenRotation) {
                    this.TextBounds.push(newWordBounds);
                    this.TextContent.push(wordBounds[parseInt(count.toString(), 10)].Text);
                }
            }
            if (hasInBetweenRotation) {
                this.TextBounds.push(newWordBounds);
                this.TextContent.push(inBetweenRotatedText);
            }
        }
        checkIsRtlText(text) {
            const ltrChars = 'A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02B8\\u0300-\\u0590\\u0800-\\u1FFF' + '\\u2C00-\\uFB1C\\uFDFE-\\uFE6F\\uFEFD-\\uFFFF';
            const rtlChars = '\\u0591-\\u07FF\\uFB1D-\\uFDFD\\uFE70-\\uFEFC';
            // eslint-disable-next-line
            const rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');
            return rtlDirCheck.test(text);
        }
        getPageRender(n = 0, w, h, isTextNeed, isTransparent, cropBoxRect, mediaBoxRect, isSkipCharacterBounds) {
            const pageRenderPtr = this.getRender(n, w, h, isTextNeed, isTransparent, cropBoxRect, mediaBoxRect, isSkipCharacterBounds);
            let pageRenderData = [];
            pageRenderData = PDFiumModule.HEAPU8.slice(pageRenderPtr, pageRenderPtr + (w * h * 4));
            const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                ? PDFiumModule.asm.free
                : PDFiumModule._free;
            freeFunction(pageRenderPtr);
            return pageRenderData;
        }
        render(n = 0, message, zoomFactor, isTextNeed, printScaleFactor, printDevicePixelRatio, textDetailsId, isTransparent, cropBoxRect, mediaBoxRect, size, isSkipCharacterBounds, imageSize) {
            let [w, h] = this.getPageSize(n);
            if (isNaN(w) && isNaN(h)) {
                const page = FPDF.LoadPage(this.wasmData.wasm, n);
                h = this.pointerToPixelConverter(FPDF.GetPageHeight(page));
                w = this.pointerToPixelConverter(FPDF.GetPageWidth(page));
            }
            const scaleFactor = 1.5;
            const thumbnailWidth = 99.7;
            const thumbnailHeight = 141;
            if (message === 'thumbnail') {
                const newWidth = Math.round(thumbnailWidth * scaleFactor * (imageSize ? imageSize : 1));
                const newHeight = Math.round(thumbnailHeight * scaleFactor * (imageSize ? imageSize : 1));
                const data = this.getPageRender(n, newWidth, newHeight, isTextNeed, null, null, null, isSkipCharacterBounds);
                return { value: data, width: newWidth, height: newHeight, pageIndex: n, message: 'renderThumbnail', textBounds: this.TextBounds, textContent: this.TextContent, rotation: this.Rotation, pageText: this.PageText, characterBounds: this.CharacterBounds, zoomFactor: zoomFactor, isTextNeed: isTextNeed, textDetailsId: textDetailsId, imageSize: imageSize };
            }
            else if (message === 'print') {
                //An A0 piece of paper measures 33.1 × 46.8 inches, with 46.8 inches being the greater dimension. The pixel value of 46.8 inches is 4493px. If the document size is too large, we may not be able to display the image. Therefore, we should consider the maximum size of A0 paper if the page size is greater than 4493 pixels.
                const maxPageSize = 4493;
                const scaleFactor = 1.5;
                const whichIsBigger = (w > h) ? 'Width' : 'Height';
                let maxWidth = w;
                let maxHeight = h;
                if (whichIsBigger === 'Width') {
                    maxWidth = (w > maxPageSize) ? maxPageSize : w;
                    if (maxWidth === maxPageSize) {
                        maxHeight = h / (w / maxPageSize);
                    }
                }
                else {
                    maxHeight = (h > maxPageSize) ? maxPageSize : h;
                    if (maxHeight === maxPageSize) {
                        maxWidth = w / (h / maxPageSize);
                    }
                }
                const newWidth = Math.round(maxWidth * printScaleFactor * scaleFactor);
                const newHeight = Math.round(maxHeight * printScaleFactor * scaleFactor);
                const data = this.getPageRender(n, newWidth, newHeight, false, null, null, null, isSkipCharacterBounds);
                return { value: data, width: newWidth, height: newHeight, pageIndex: n, pageWidth: w, pageHeight: h, message: 'printImage', printDevicePixelRatio };
            }
            else {
                let newWidth = Math.round(((size && size !== null) ? size.width : w) * scaleFactor * zoomFactor);
                let newHeight = Math.round(((size && size !== null) ? size.height : h) * scaleFactor * zoomFactor);
                // Reduce the zoom factor if the new image size exceeds the memory limit
                while (((newWidth * newHeight * 4) * 2) >= 2147483648) {
                    zoomFactor = zoomFactor - 0.1;
                    newWidth = Math.round(this.pointerToPixelConverter(w) * zoomFactor);
                    newHeight = Math.round(this.pointerToPixelConverter(h) * zoomFactor);
                }
                let data = null;
                if (message === 'extractText') {
                    const page = FPDF.LoadPage(this.wasmData.wasm, n);
                    this.textExtraction(page, n, isTextNeed, cropBoxRect, mediaBoxRect, isSkipCharacterBounds);
                    FPDF.ClosePage(page);
                }
                else {
                    data = this.getPageRender(n, newWidth, newHeight, isTextNeed, isTransparent, cropBoxRect, mediaBoxRect, isSkipCharacterBounds);
                }
                return { value: data, width: newWidth, height: newHeight, pageWidth: w, pageHeight: h, pageIndex: n, message: 'imageRendered', textBounds: this.TextBounds, textContent: this.TextContent, rotation: this.Rotation, pageText: this.PageText, characterBounds: this.CharacterBounds, zoomFactor: zoomFactor, isTextNeed: isTextNeed, textDetailsId: textDetailsId };
            }
        }
        renderTileImage(n = 0, tileX, tileY, xCount, yCount, zoomFactor, isTextNeed, textDetailsId, cropBoxRect, mediaBoxRect) {
            const [w, h] = this.getPageSize(n);
            const newWidth = Math.round(w * 1.5 * zoomFactor);
            const newHeight = Math.round(h * 1.5 * zoomFactor);
            const w1 = Math.round(newWidth / xCount);
            const h1 = Math.round(newHeight / yCount);
            const flag = FPDF.REVERSE_BYTE_ORDER;
            const mallocFunction = PDFiumModule.asm && PDFiumModule.asm.malloc
                ? PDFiumModule.asm.malloc
                : PDFiumModule._malloc;
            const heap = mallocFunction(w1 * h1 * 4);
            PDFiumModule.HEAPU8.fill(0, heap, heap + (w1 * h1 * 4));
            const bmap = FPDF.Bitmap_CreateEx(w1, h1, 4, heap, w1 * 4);
            const page = FPDF.LoadPage(this.wasmData.wasm, n);
            FPDF.Bitmap_FillRect(bmap, 0, 0, w1, h1, 0xFFFFFFFF);
            FPDF.RenderPageBitmap(bmap, page, -tileX * w1, -tileY * h1, newWidth, newHeight, 0, flag);
            FPDF.Bitmap_Destroy(bmap);
            this.textExtraction(page, n, isTextNeed, cropBoxRect, mediaBoxRect);
            FPDF.ClosePage(page);
            const pageRenderPtr = heap;
            let data = [];
            data = PDFiumModule.HEAPU8.slice(pageRenderPtr, pageRenderPtr + (w1 * h1 * 4));
            const freeFunction = PDFiumModule.asm && PDFiumModule.asm.free
                ? PDFiumModule.asm.free
                : PDFiumModule._free;
            freeFunction(pageRenderPtr);
            if (tileX === 0 && tileY === 0) {
                return {
                    value: data,
                    w: w1,
                    h: h1,
                    noTileX: xCount,
                    noTileY: yCount,
                    x: tileX,
                    y: tileY,
                    pageIndex: n,
                    message: 'renderTileImage',
                    textBounds: this.TextBounds,
                    textContent: this.TextContent,
                    rotation: this.Rotation,
                    pageText: this.PageText,
                    characterBounds: this.CharacterBounds,
                    textDetailsId: textDetailsId,
                    isTextNeed: isTextNeed,
                    zoomFactor: zoomFactor
                };
            }
            else {
                return {
                    value: data,
                    w: w1,
                    h: h1,
                    noTileX: xCount,
                    noTileY: yCount,
                    x: tileX,
                    y: tileY,
                    pageIndex: n,
                    message: 'renderTileImage',
                    textDetailsId: textDetailsId,
                    isTextNeed: isTextNeed,
                    zoomFactor: zoomFactor
                };
            }
        }
        getLastError() {
            const lastError = FPDF.GetLastError();
            switch (lastError) {
                case FPDF.LAST_ERROR.SUCCESS:
                    return 'success';
                case FPDF.LAST_ERROR.UNKNOWN:
                    return 'unknown error';
                case FPDF.LAST_ERROR.FILE:
                    return 'file not found or could not be opened';
                case FPDF.LAST_ERROR.FORMAT:
                    return 'file not in PDF format or corrupted';
                case FPDF.LAST_ERROR.PASSWORD:
                    return 'password required or incorrect password';
                case FPDF.LAST_ERROR.SECURITY:
                    return 'unsupported security scheme';
                case FPDF.LAST_ERROR.PAGE:
                    return 'page not found or content error';
                default:
                    return 'unknown error';
            }
        }
    }
    /**
     * @hidden
     */
    class SizeF {
        constructor(Width, Height) {
            this.Width = Width;
            this.Height = Height;
            this.IsEmpty = Width === 0 ? (Height === 0 ? true : false) : false;
        }
    }
    class DocumentInfo {
        constructor(wasmData) {
            this.pages = [];
            this.pageSizes = {};
            this.pageRotation = [];
            this.processor = new Processor(wasmData);
        }
        setPages(pagesCount) {
            this.pages = Array(pagesCount).fill(null);
        }
        createAllPages() {
            for (let i = 0; i < this.pages.length; i++) {
                this.pages[parseInt(i.toString(), 10)] = new Page(parseInt(i.toString(), 10), this.processor);
                this.pages[parseInt(i.toString(), 10)] = new Page(i, this.processor);
                const currentPageSize = this.processor.getPageSize(i);
                this.pageSizes[parseInt(i.toString(), 10)] = new SizeF(currentPageSize[0], currentPageSize[1]);
                const page = FPDF.LoadPage(documentDetails.processor.wasmData.wasm, i);
                const rotation = FPDF.GetPageRotation(page);
                FPDF.ClosePage(page);
                this.pageRotation.push(rotation);
            }
        }
        getPage(index) {
            let page = this.pages[parseInt(index.toString(), 10)];
            if (!page) {
                page = new Page(index);
                this.pages[parseInt(index.toString(), 10)] = page;
            }
            return page;
        }
    }
}
